import G6 from '@antv/g6';

const toolTip = new G6.Tooltip({
    // offsetX 与 offsetY 需要加上父容器的 padding
    offsetX: 50,
    offsetY: -60,
    // 允许出现 tooltip 的 item 类型
    itemTypes: ['node'],
    shouldBegin: e => {
        let billno = e.item.getModel().billno;
        let title = e.item.getModel().title;
        if (billno.indexOf('...') !== -1 || title.indexOf('...') !== -1) {
            return true
        } else {
            return false
        }

    },
    // 自定义 tooltip 内容
    getContent(e) {
        const outDiv = document.createElement('div');
        outDiv.style.maxWidth = '350px';
        outDiv.innerHTML = `
      <ul>
      <li>${e.item.getModel().tooltipLabel}:${e.item.getModel().billTypeName}</li>
        <li> ${e.item.getModel().label} : ${e.item.getModel().billCode}</li>
      </ul>`
        return outDiv;
    },
});

// const miniMap = new G6.Minimap({
//     size: [130, 100],
//     className: "uap-minimap",
// });

const defaultEdge = {
    type: 'cubic-horizontal',
    style: {
        // radius: 20,
        offset: 35,
        endArrow: true,
        lineWidth: 1,
        stroke: '#999',
    },
}

// const defaultNode = {
//     type: 'rect',
//     size: [160, 80],
//     style: {
//         // fill: '#9EC9FF',
//         // stroke: '#5B8FF9',
//         lineWidth: 3,
//     },
//     labelCfg: {
//         style: {
//             fill: '#fff',
//             fontSize: 18,
//         },
//     },
//     linkPoints: {
//         top: false,
//         bottom: false,
//         left: true,
//         right: false,
//         size: 10,
//         fill: '#fff',
//         lineWidth: 1,
//         stroke: '#1890FF',
//     },
// };

export default {
    toolTip,
    // miniMap,
    defaultEdge,
    // defaultNode,
}